import { useTranslation } from "react-i18next";

export default function ResultPendingDots({ className = "" }) {
  const { t } = useTranslation();
  const accessibleLabel = t("result.metricCalculating", "Calculating…");

  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={accessibleLabel}
      className={["result-pending-dots", className].filter(Boolean).join(" ")}
    >
      <span className="sr-only">{accessibleLabel}</span>
      <span aria-hidden="true" className="result-pending-dots__track">
        <span className="result-pending-dots__dot" />
        <span className="result-pending-dots__dot" />
        <span className="result-pending-dots__dot" />
      </span>
    </span>
  );
}
